module.exports = __webpack_public_path__ + "img/activity4.ac598839.png";